import React, { Component } from 'react';
import { Switch } from "react-router-dom";
import { RouterControl } from '@/router/index';

class System extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    return <div className='mib-h5'>
      {/* h5路径 */}
      <Switch>
        {this.props.routes.map((route, i) => (
          <RouterControl key={i} {...route} />
        ))}
      </Switch>
    </div>
  }
}

export default System;
